import Page, { PageDOMProps } from "../page";
import { useIntl, FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export interface NoOrganizationToManageDOMProps extends PageDOMProps {}
export interface NoOrganizationToManageProps
  extends NoOrganizationToManageDOMProps {}
function NoOrganizationToManage(props: NoOrganizationToManageProps) {
  const intl = useIntl();
  const title = intl.formatMessage({
    defaultMessage: "Not authorized",
    description: "heading for the page",
  });
  const description = intl.formatMessage({
    defaultMessage: "Your account is not authorized.",
    description: "window meta description for the screen",
  });
  return (
    <Page
      data-test-no-organization-to-manage
      header={
        <h1 className={"text-danger text-center"}>
          <FontAwesomeIcon icon="exclamation-triangle" className="mr-2" />{" "}
          {title}
        </h1>
      }
      meta={{
        title,
        description,
      }}
      {...props}
    >
      <p className={"text-center"}>
        <FormattedMessage
          defaultMessage="Your account is not authorized to manage an organization."
          description={"message for no organizations to manage"}
        />
      </p>
    </Page>
  );
}
export default NoOrganizationToManage;
